import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Timeline from 'components/Timeline';

import PatientJourneyCard from './PatientJourneyCard';
import PatientJourneyCardYear from './PatientJourneyCard/PatientJourneyCardYear';
import PatientJourneyCardDialogMessages from './PatientJourneyCard/PatientJourneyCardDialogMessages';

class PatientJourneyTimeline extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dialogMessagesOpen: false,
      event: false,
    };
  }

  getEventContent = (event) => {
    const { patient, onEventSelected } = this.props;
    if (event.details) {
      return (
        <PatientJourneyCard
          event={event}
          patient={patient}
          onClickMessages={() => this.setState({ dialogMessagesOpen: true, event })}
        />
      );
    }
    return <PatientJourneyCardYear event={event} onClick={() => onEventSelected(event)} />;
  };

  render() {
    const { events, date, patient, permissions, singleline } = this.props;
    const { event, dialogMessagesOpen } = this.state;

    return (
      <>
        <Timeline
          singleline={singleline}
          events={events}
          date={date}
          headerDate={patient.dateOfBirthValue}
          handleRenderEventContent={this.getEventContent}
        />
        <PatientJourneyCardDialogMessages
          singleline={singleline}
          open={dialogMessagesOpen}
          event={event || {}}
          patient={patient}
          permissions={permissions}
          onClose={() => this.setState({ dialogMessagesOpen: false, event: false })}
        />
      </>
    );
  }
}

PatientJourneyTimeline.propTypes = {
  patient: PropTypes.object.isRequired,
  events: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.bool]),
  date: PropTypes.string,
  onEventSelected: PropTypes.func,
  permissions: PropTypes.object.isRequired,
};

export default PatientJourneyTimeline;
